"use client";

import { c as _c } from "react/compiler-runtime";
import { createContext, useContext, useEffect } from "react";
import i18next, { type FlatNamespace, type KeyPrefix } from "i18next";
import { FallbackNs, UseTranslationOptions, initReactI18next, useTranslation as useTranslationOrg } from "react-i18next";
import { fallbackLng, Locales, type LocaleName, defaultNS, isLocale } from "./settings";
import HttpApi from "i18next-http-backend";
import resourcesToBackend from "i18next-resources-to-backend";
const runsOnServerSide = typeof window === "undefined";
class LanguageDetector {
  type: "languageDetector";
  constructor() {
    this.type = "languageDetector";
  }
  detect() {
    if (runsOnServerSide) {
      return null;
    }
    const htmlLang = document.documentElement.lang;
    if (htmlLang && isLocale(htmlLang)) {
      return htmlLang;
    }
    const pathLang = window.location.pathname.split("/")[1];
    if (pathLang && isLocale(pathLang)) {
      return pathLang;
    }
    return fallbackLng;
  }
}
// @ts-expect-error Ist okay. Braucht i18next zum feststellen des types
LanguageDetector.type = "languageDetector";
i18next.use(initReactI18next).use(LanguageDetector).use(
// Hier wird translation für den client gemacht
// Wir machen aber trotzdem SSR auf dem Server
// auf den server können wir ruhig alles laden
// auf den client sollte wir nur on demand laden
// @ts-expect-error probably because all client code is compiled for both server and client?
typeof window !== "undefined" ? HttpApi : resourcesToBackend((language: string, namespace: string) => import(`../../../public/locales/${language}/${namespace}.json`))).init({
  debug: false,
  supportedLngs: Locales,
  fallbackLng,
  fallbackNS: defaultNS,
  defaultNS,
  ns: defaultNS,
  lng: undefined,
  // let detect the language on client side
  preload: runsOnServerSide ? Locales : [],
  // Wir have nur language tags eg: de, en, es,...
  load: "languageOnly"
});
export const LocaleContext = createContext<LocaleName>(fallbackLng);
export function useLocaleContext() {
  return useContext(LocaleContext);
}
export function useTranslation(ns, options) {
  const $ = _c(6);
  const lng = useLocaleContext();
  const t0 = options?.lng ?? lng;
  let t1;
  if ($[0] !== options || $[1] !== t0) {
    t1 = {
      ...options,
      lng: t0
    };
    $[0] = options;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const translation = useTranslationOrg(ns, t1);
  let t2;
  let t3;
  if ($[3] !== lng) {
    t2 = () => {
      if (i18next.resolvedLanguage !== lng) {
        i18next.changeLanguage(lng);
      }
    };
    t3 = [lng];
    $[3] = lng;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  return translation;
}